
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaUserCircle, FaArrowLeft, FaBars } from "react-icons/fa";
import { sellerPageTitles } from "./Util/sellerPageTitles";

const SellerHeader = ({ setSidebarOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const pageTitle =
        sellerPageTitles[location.pathname] || "Seller Panel";

    return (
        <header className="sticky top-0 z-30 bg-white border-b px-4 sm:px-6 py-4 flex items-center justify-between">

            {/* LEFT */}
            <div className="flex items-center gap-3">

                {/* Mobile Sidebar Button */}
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="md:hidden p-2 rounded-md hover:bg-gray-100 transition"
                >
                    <FaBars className="text-lg text-gray-700" />
                </button>

                {/* Back Button (optional – mobile only) */}
                <button
                    onClick={() => navigate(-1)}
                    className="hidden sm:hidden p-2 rounded-md hover:bg-gray-100 transition"
                >
                    <FaArrowLeft className="text-lg text-gray-700" />
                </button>

                {/* Page Title */}
                <h1 className="mt-1 text-lg sm:text-xl font-semibold text-gray-800">
                    {pageTitle}
                </h1>
            </div>

            {/* RIGHT */}
            <NavLink
                to="/seller/profile"
                className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-gray-100 transition"
            >
                <FaUserCircle className="text-xl text-gray-800" />
                <span className="hidden sm:block text-sm font-bold text-gray-700">
                    Profile
                </span>
            </NavLink>
        </header>
    );
};

export default SellerHeader;
